<script setup lang="ts">
const videoEl = ref<HTMLVideoElement | null>(null);
const bgVideoEl = ref<HTMLVideoElement | null>(null);

onMounted(() => {
  const { isIos } = useDevice();
  if (!videoEl.value) return;

  const playOne = (el: HTMLVideoElement | null) => {
    el?.play().catch((e) => console.debug('Autoplay blocked:', e));
  };

  // Attempt initial play for both videos
  playOne(videoEl.value);
  playOne(bgVideoEl.value);

  // Safari workaround: Play after first interaction
  const onInteract = () => {
    playOne(videoEl.value);
    playOne(bgVideoEl.value);
  };
  document.addEventListener('click', onInteract, { once: true });
  document.addEventListener('touchstart', onInteract, { once: true });

  // Preload technique for Safari
  if (isIos) {
    videoEl.value?.load();
    bgVideoEl.value?.load();
  }
});
const videoMp4 = `/video/switchcase.mp4`;
const videoWebm = `/video/switchcase.webm`;
</script>

<template>
  <section id="video" class="video-wrapper">
    <video
      ref="bgVideoEl"
      class="bg-video"
      playsinline
      webkit-playsinline
      x5-video-player-type="h5"
      muted
      loop
      autoplay
      preload="auto"
      aria-hidden="true"
    >
      <source :src="videoWebm" type="video/webm" />
      <source :src="videoMp4" type="video/mp4" />
    </video>

    <video
      ref="videoEl"
      class="video"
      playsinline
      webkit-playsinline
      x5-video-player-type="h5"
      muted
      loop
      autoplay
      preload="auto"
    >
      <source :src="videoWebm" type="video/webm" />
      <source :src="videoMp4" type="video/mp4" />
    </video>
  </section>
</template>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.bg-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(24px) saturate(1.05);
  transform: scale(1.1);
  will-change: transform, filter;
  pointer-events: none;
  z-index: 0;
}

.video {
  position: relative;
  z-index: 1;
  height: 100%;
  width: auto;
  max-width: 100vw;
  object-fit: contain;
}

@media (max-width: 743px) {
  .video-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

  .bg-video {
    display: none;
  }
}
</style>
